// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Ih","categoryName":"Jh","categoryImage":"Kh","categoryContent":"Lh","bottomAligned":"Mh"};